import * as server from "@/utils/http"


//查詢列表接口
export const _getSmenuList = params =>
  server.get("/sysMenu/selectPages",params); // 列表
//获取所有一级菜单
export const _getfindParent=()=> server.get("/sysMenu/findParent")
//新增菜单
export const _getSmenuUpdate=(params)=> server.post(params.id?"/sysMenu/update":'/sysMenu/save',params)
//删除
export const _delSmenu = params => server.get("/sysMenu/delete", params); // 删除


